import { render, staticRenderFns } from "./GovernoratesView.vue?vue&type=template&id=6da74c6e"
import script from "./GovernoratesView.vue?vue&type=script&lang=js"
export * from "./GovernoratesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports